/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsRosterListMemberPreviewDtoSchema } from "./rosterListMemberPreviewDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterListItemDtoSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  tag: z.string().nullish(),
  icon: z.string().nullish(),
  logoUrl: z.string().nullish(),
  banner: z.string().nullish(),
  memberCount: z.optional(z.int()),
  maxMembers: z.optional(z.int()),
  isLookingForPlayers: z.optional(z.boolean()),
  isVerified: z.optional(z.boolean()),
  createdAt: z.optional(z.iso.datetime()),
  averageRank: z.string().nullish(),
  get members() {
    return z.array(goodLuckCoreDTOsRosterListMemberPreviewDtoSchema).nullish();
  },
});
